import React from 'react';
import PropTypes from 'prop-types';
import { Button, Chip, Stack } from '@mui/material';
import UsbIcon from '@mui/icons-material/Usb';
import UsbOffIcon from '@mui/icons-material/UsbOff';

export default function SerialConnectButton({ connected, onConnect, onDisconnect, disabled = false, firmware = null }) {
  if (connected) {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <Chip
          icon={<UsbIcon />}
          label={firmware ? `Connected (v${firmware})` : 'Connected'}
          color="success"
          variant="outlined"
        />
        <Button
          variant="outlined"
          color="error"
          size="small"
          startIcon={<UsbOffIcon />}
          onClick={onDisconnect}
          aria-label="Disconnect"
        >
          Disconnect
        </Button>
      </Stack>
    );
  }

  return (
    <Button
      variant="contained"
      startIcon={<UsbIcon />}
      onClick={onConnect}
      disabled={disabled}
    >
      Connect Device
    </Button>
  );
}

SerialConnectButton.propTypes = {
  connected: PropTypes.bool.isRequired,
  onConnect: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  firmware: PropTypes.string,
};

